import { render, staticRenderFns } from "./SyncGroupDocument.vue?vue&type=template&id=07d871a2"
import script from "./SyncGroupDocument.vue?vue&type=script&lang=js"
export * from "./SyncGroupDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports